import React from "react";

const Header = ({ onClick, style, node }) => {
  return (
    <div className="node_title" onClick={() => onClick(node)}>
      {node.name}
    </div>
  );
};

export default Header;
